export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1760443101675-d42daf465e24?crop=entropy&cs=srgb&fm=jpg&q=85",
  atrium: "https://images.unsplash.com/photo-1776775094589-6be8efe087bb?crop=entropy&cs=srgb&fm=jpg&q=85",
  equipment: "https://images.unsplash.com/photo-1779345169505-be7319f62b97?crop=entropy&cs=srgb&fm=jpg&q=85",
  facade: "https://images.pexels.com/photos/20381389/pexels-photo-20381389.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  hallway: "https://images.pexels.com/photos/18006813/pexels-photo-18006813.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const VIDEO_URL = "/videos/hero-bundler.mp4";
export const VIDEO_WEBM_URL = "/videos/hero-bundler.webm";
export const VIDEO_POSTER = "/videos/hero-poster.jpg";

export const TEAM = [
  {
    key: "geschaeftsfuehrung",
    nameDe: "Aleksandar Veljkovic",
    nameEn: "Aleksandar Veljkovic",
    nameSh: "Aleksandar Veljkovic",
    nameHi: "Aleksandar Veljkovic",
    roleDe: "Geschäftsführung",
    roleEn: "Managing Director",
    roleSh: "Direktor",
    roleHi: "प्रबंध निदेशक",
    email: "aleksandar.veljkovic@bundler-fm.de",
    image: "https://images.unsplash.com/photo-1718209881007-c0ecdfc00f9d?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    key: "kaufmaennisch",
    nameDe: "Kaufmännische Abteilung",
    nameEn: "Commercial Department",
    nameSh: "Komercijalni odjel",
    nameHi: "वाणिज्यिक विभाग",
    roleDe: "Angebote · Rechnungen · Verwaltung",
    roleEn: "Quotes · Invoices · Administration",
    roleSh: "Ponude · Računi · Administracija",
    roleHi: "कोटेशन · चालान · प्रशासन",
    email: "kaufmaennisch@bundler-fm.de",
    image: "/team/kaufmaennisch.jpg",
  },
  {
    key: "technik",
    nameDe: "Technische Abteilung",
    nameEn: "Technical Department",
    nameSh: "Tehnički odjel",
    nameHi: "तकनीकी विभाग",
    roleDe: "Objektleitung · Technik · Einsatzplanung",
    roleEn: "Operations · Technology · Scheduling",
    roleSh: "Rukovođenje objektima · Tehnika · Planiranje",
    roleHi: "संचालन · तकनीक · नियोजन",
    email: "technik@bundler-fm.de",
    image: "/team/technik.jpg",
  },
];

export const translations = {
  de: {
    nav: {
      usp: "Stärken",
      services: "Leistungen",
      team: "Team",
      references: "Referenzen",
      contact: "Kontakt",
      cta: "Anfrage senden",
    },
    hero: {
      label: "Facility Management — neu gedacht",
      line1: "Saubere öffentliche Gebäude.",
      line2: "Digitale Prozesse.",
      line3: "Keine Sprachbarrieren.",
      sub: "BUNDLER FM ist Ihr Partner für die Unterhaltsreinigung öffentlicher Gebäude — mit festen Teams, KI-gestützter kaufmännischer Abwicklung und Kommunikation ohne Sprachbarrieren.",
      ctaPrimary: "Kostenlose Anfrage stellen",
      ctaSecondary: "Leistungen entdecken",
      pills: ["Modulares Reinigen", "Feste Teams", "DE · EN · SR/HR · HI · KI-Assistenz"],
      videoCaption: "Unsere Teams im Einsatz — mit System, Profi-Material & Reinigungsroboter",
      scroll: "Nach unten scrollen",
    },
    usp: {
      label: "Unsere Stärke",
      title: "Öffentliche Gebäude brauchen mehr als Reinigung. Sie brauchen Verlässlichkeit mit System.",
      sub: "Sechs Gründe, warum öffentliche Auftraggeber auf BUNDLER FM setzen. Klicken Sie auf eine Stärke für mehr Details.",
      cards: [
        {
          title: "Spezialisiert auf öffentliche Auftraggeber",
          text: "Behörden, Schulen, Gemeinden, Institute: Wir denken wie der öffentliche Träger — und bereiten den Objektstart vor, bevor er beginnt.",
          more: "Nach der Zuschlagserteilung bleibt keine Zeit: Personal muss beschafft, geschult und eingewiesen werden — an Universitäten etwa in sensiblen Bereichen wie Laboren und S-Räumen. Dazu kommen Jahreszeiten-Effekte: Urlaubszeiten, erhöhte Krankenstände, Schulferien — sie treffen Institute und Dienstleister gleichermaßen. Wer das nicht vorbereitet, startet mit Personallücken, und die Qualität bricht genau in der kritischen Anlaufphase ein. Diese Vorbereitung ist unser Kerngeschäft: geografische Analyse der Gebäude, Öffnungszeiten, Bereiche mit Fristen, Personalplanung über Urlaubs- und Ferienzeiten hinweg — unsere zentrale KI übernimmt einen Großteil der Vorbereitung zum Projektstart. Personal ist zu 100 % vorhanden und wird gezielt für Ihr Objekt ausgewählt. Wir sprechen Institute direkt an — ohne Vermittlungskontakte. So hat Ihre Operative eine funktionsfähige Infrastruktur, um die angebotene Leistung zu erbringen. Und wenn Sie es wünschen: Alle erarbeiteten Schritte stellen wir nach Abschluss Ihrer Leitungsebene zur Verfügung.",
        },
        {
          title: "Feste Teams — exakt auf Ihr Objekt ausgewählt",
          text: "Kein Zufall bei der Personalauswahl: Wir besetzen Ihr Objekt mit Mitarbeitenden, die exakt zu Ihren Anforderungen passen.",
          more: "Wechselnde Gesichter bedeuten jedes Mal neue Einarbeitung. Besetzungslücken in Urlaubs- und Ferienzeiten führen zu sichtbaren Qualitätseinbrüchen — und unklare Schlüsselregelungen werden im öffentlichen Bereich zum Sicherheitsproblem. Deshalb wählen wir für jedes Objekt unsere Mitarbeitenden gezielt aus — nach Uhrzeiten, den Anforderungen Ihres Leistungsverzeichnisses, Alter, Sprachkenntnissen und Mobilität. Dabei berücksichtigen wir auch die privaten Möglichkeiten unserer Teams, damit die Besetzung dauerhaft stabil bleibt. Urlaubszeiten regeln wir mit früh eingeplanten Vertretungen, Schlüsselübergaben und Schlüsselführung sind fest organisiert. Ergebnis: zeitlich fixe Abläufe, die gleichzeitig flexibel bleiben — und immer dieselben Gesichter bei Ihnen vor Ort.",
        },
        {
          title: "Objektstart & Koordination — wir nehmen Ihnen alles ab",
          text: "Vom Objektstart bis zur laufenden Betreuung: Wir koordinieren eigenständig — administrativ und vor Ort.",
          more: "Der Objektstart entscheidet über den ganzen Vertrag: Räume müssen bis zu festen Uhrzeiten fertig sein, Veranstaltungen laufen weiter — und beim Dienstleisterwechsel drohen Wissensverlust und rechtliche Stolpersteine: Beim Betriebsübergang nach § 613a BGB geht Personal des Vorgängers unter Umständen mit allen Rechten über; bleibt das ungeprüft, entstehen Versorgungslücken und Haftungsfragen genau zum Start. Wir bestücken Ihr Objekt exakt nach Bedarf — zum Beispiel an einer Universität mehrere Hörsäle gleichzeitig bis zu einer festen Uhrzeit. Wir übernehmen Veranstaltungskoordination, Unterstützung, Aushilfe und servicenahe Leistungen jeglicher Art und prüfen beim Wechsel frühzeitig die rechtlichen Rahmenbedingungen — damit weder Wissen noch Versorgung verloren geht. Ihre Ansprechpartner arbeiten wir gemeinsam aus, Begehungskontrollen regeln Sie direkt mit uns. Administrative und lokale Abläufe nimmt Ihnen BUNDLER FM ab: Planung individuell nach Ihrem Bedarf, Abnahme durch uns statt durch Sie.",
        },
        {
          title: "Digitales Backoffice mit KI",
          text: "Anfragen, Rechnungen und Nachweise laufen digital und KI-gestützt — schnell, präzise, ohne Papierchaos.",
          more: "Papierchaos und unklare Rechnungen kosten Verwaltungen Zeit. Fehlende digitale Nachweise werden bei Prüfungen und Controlling zum Problem — und Anfragen versanden in überfüllten Postfächern. Bei uns landet Ihre Anfrage automatisch beim richtigen Ansprechpartner: Unsere KI erkennt, ob es um Technik, Kaufmännisches oder die Geschäftsführung geht, und leitet sofort weiter. Rechnungen und Leistungsnachweise verarbeiten wir digital und KI-gestützt — perspektivisch auch direkt angebunden an Buchhaltungssysteme wie lexoffice. Für Sie heißt das: weniger Verwaltungsaufwand, schnellere Antworten, transparente Abläufe.",
        },
        {
          title: "Kommunikation ohne Sprachbarrieren",
          text: "Live-Übersetzung übers Headset: Ihre Reinigungskraft spricht ihre Sprache — Sie hören sie sofort auf Deutsch.",
          more: "Wenn Anweisungen an der Sprache scheitern, werden Leistungen falsch oder gar nicht ausgeführt — in sensiblen Bereichen wie Laboren kann das zum Sicherheitsrisiko werden, und Beschwerden eskalieren, weil niemand versteht, wo das Problem liegt. Unsere Teams arbeiten mehrsprachig — bei uns ist das kein Hindernis, sondern Stärke: Über KI-gestützte Headsets übersetzen wir live in beide Richtungen. Ihre Reinigungskraft spricht zum Beispiel Serbokroatisch ins Headset — Sie hören die Übersetzung in Echtzeit auf Deutsch in Ihrem Ohr. Und umgekehrt. So kommt jede Information verlustfrei an — direkt, persönlich, ohne Umwege.",
        },
        {
          title: "Digitale Raumbücher & Objektdaten",
          text: "Raumbücher, Räume und Bodenbeläge immer aktuell: KI-gestützte Datenauswertung — geprüft durch echte Begehungen unseres Technik-Teams.",
          more: "Veraltete Raumbücher sind ein verstecktes Risiko: Welche Räume wurden aktualisiert? Stimmen die tatsächlichen Raumgruppen? Wurden Baumaßnahmen eingepflegt? Welche Bodenbeläge gibt es wirklich? Falsche Daten führen zu falschen Angeboten und teuren Nachkalkulationen. Wir kalkulieren exakt nach Ihrem tatsächlichen Bedarf — unabhängig davon, welche Beläge oder Raumtypen Ihr Objekt hat. So stellen wir sicher, dass Nachkalkulationen nahezu nicht vorkommen. Unsere KI wertet Ihre Raumbuch-Daten aus und erkennt Lücken; unser technikversiertes Team prüft bei echten Begehungen vor Ort, ob Räume, Raumgruppen und Baumaßnahmen aktuell sind, und ergänzt das Raumbuch direkt im Objekt. Inbetriebnahmen, Ausbaumaßnahmen und Erweiterungen betrachten wir gesondert — damit Ihre Datenbasis immer stimmt.",
        },
      ],
    },
    services: {
      label: "Leistungen",
      title: "Unterhaltsreinigung — mitten im operativen Tagesablauf",
      chapters: [
        {
          num: "01",
          tag: "Unsere Methode",
          title: "Modulares Reinigen — unsere eigene Arbeitsweise",
          text: "Statt starrer Reinigungspläne nach Schema F arbeiten wir mit einem selbst entwickelten modularen System, das sich exakt auf Ihren Betrieb und Ihre Öffnungszeiten einstellt. Was genau dahintersteckt, zeigen wir Ihnen gern persönlich — zum Beispiel im Rahmen Ihrer Ausschreibung. Für Sie zählt das Ergebnis: Reinigung, die sich Ihrem Tag anpasst — nicht umgekehrt.",
        },
        {
          num: "02",
          tag: "Warum so effizient",
          title: "Digitale Prozesse verschlanken jeden Schritt",
          text: "Anfragen laufen automatisch zur richtigen Stelle, Rücksprachen vor Ort halten wir per Headset-Live-Übersetzung ohne Verzögerung, Leistungsnachweise entstehen digital. Keine Medienbrüche, keine Wartezeiten, keine doppelten Wege — das spart jeden Tag Stunden.",
        },
        {
          num: "03",
          tag: "Kosten & Qualität",
          title: "Gleiche Qualität, weniger Kosten",
          text: "Weil wir exakt nach Ihrem Bedarf kalkulieren statt nach pauschalen Annahmen, bleiben Nachkalkulationen nahezu aus. Durch die Fokussierung auf Unterhaltsreinigung und modulare Abläufe liegt unsere Flächenleistung (m²/h) deutlich über dem Branchen-Benchmark — bei gleicher oder besserer Qualität. Feste Teams verlieren keine Einarbeitungszeit, die Verwaltung läuft digital: Das ist der Unterschied zwischen billig und wirtschaftlich.",
        },
      ],
      extraTag: "Auf Anfrage",
      extra: "Entrümpelung, Fahrservice & Posttouren, Fuhrpark- und Autoaufbereitung, Aushilfsreinigung und mehr — sprechen Sie uns an. Wir stellen das passende Leistungspaket für Ihr Gebäude zusammen.",
    },
    team: {
      label: "Team",
      title: "Ihre Ansprechpartner",
      sub: "Drei klare Ebenen, ein Anspruch: Ihre Anfrage landet immer direkt bei der richtigen Stelle — von der Geschäftsführung bis zur Abteilung.",
      emailLabel: "E-Mail schreiben",
    },
    references: {
      label: "Referenzen",
      title: "Öffentliche Gebäude sind unsere Heimat. Und unsere Erfahrung.",
      sub: "Universitäten, Schulen, Behörden, Kommunen: Genau für diese Gebäude sind wir gebaut — mit einem Team, das seit Jahren in großen öffentlichen Reinigungsprojekten arbeitet.",
      galleryCaption: "Die Gebäudetypen, für die wir arbeiten",
      gallery: ["Universitäten", "Schulen", "Behörden", "Kommunen"],
      trustLabel: "Erfahrung, die zählt",
      trust: [
        {
          title: "Langjährige Erfahrung aus Großprojekten",
          text: "Unsere Führungsebene hat jahrelang Reinigungsprojekte in großen öffentlichen Objekten verantwortet — von der Hochschule bis zur Schule. Diese Erfahrung steckt in jedem unserer Konzepte.",
        },
        {
          title: "Der Blick des öffentlichen Trägers",
          text: "Unser Technischer Leiter ist aktuell als Bereichsleiter an einer Universität tätig. Wir kennen Vergaben, Fristen und Leistungsverzeichnisse aus erster Hand — von Ihrer Seite des Tisches.",
        },
        {
          title: "Persönlich und erreichbar",
          text: "Bei uns sprechen Sie direkt mit der Geschäftsleitung — ohne Hotline, ohne Warteschleife. Erste Kunden genießen bei uns höchste Priorität und persönliche Betreuung.",
        },
      ],
      youngTitle: "Jung als Unternehmen. Erfahren als Team.",
      youngText: "BUNDLER FM ist eine UG in Gründung — unsere Referenzliste füllt sich gerade erst. Unsere Abteilungen, Prozesse und unser digitales Backoffice stehen dagegen auf jahrelanger Erfahrung aus großen öffentlichen Objekten. Wenn Sie einen Partner suchen, der jeden Auftrag persönlich ernst nimmt: Werden Sie einer unserer ersten Referenzkunden.",
      cta: "Erstkontakt aufnehmen",
    },
    marquee: [
      "Keine Sprachbarrieren — KI-gestützte Kommunikation",
      "Unterhaltsreinigung öffentlicher Gebäude",
      "Digitale Rechnungsbearbeitung",
      "Feste Teams — gleichbleibende Qualität",
      "Facility Management, neu gedacht",
    ],
    contact: {
      label: "Kontakt",
      title: "Kostenlose Anfrage stellen",
      sub: "Unverbindlich und kostenfrei. Einfach Anfrage senden — unsere KI findet im Hintergrund automatisch den richtigen Ansprechpartner für Ihr Anliegen.",
      name: "Ihr Name",
      namePh: "Max Mustermann",
      email: "Ihre E-Mail",
      emailPh: "max@beispiel.de",
      message: "Ihre Nachricht",
      messagePh: "Worum geht es? Z. B. Angebotsanfrage Unterhaltsreinigung für ein Schulgebäude …",
      submit: "Anfrage senden",
      sending: "Wird gesendet …",
      successTitle: "Anfrage erhalten",
      success: "Vielen Dank! Unsere KI hat Ihre Anfrage automatisch an den zuständigen Ansprechpartner weitergeleitet.",
      error: "Etwas ist schiefgegangen. Bitte versuchen Sie es erneut oder schreiben Sie an info@bundler-fm.de.",
      free: "Kostenlos · Unverbindlich · Antwort in der Regel innerhalb von 24 Stunden",
      aiHint: "Keine Auswahl nötig — die KI sucht und findet im Hintergrund den richtigen Ansprechpartner",
    },
    footer: {
      tagline: "Facility Management — neu gedacht.",
      company: "BUNDLER FM UG (in Gründung)",
      address: "Zum Isetal 1 · 38518 Gifhorn",
      phone: "Tel. +49 5371 9394742",
      email: "info@bundler-fm.de",
      socialSoon: "Social Media folgt in Kürze",
      rights: "© 2026 BUNDLER FM. Alle Rechte vorbehalten.",
      admin: "Admin",
    },
  },
  en: {
    nav: {
      usp: "Strengths",
      services: "Services",
      team: "Team",
      references: "References",
      contact: "Contact",
      cta: "Send inquiry",
    },
    hero: {
      label: "Facility management — reimagined",
      line1: "Spotless public buildings.",
      line2: "Digital processes.",
      line3: "No language barriers.",
      sub: "BUNDLER FM is your partner for the maintenance cleaning of public buildings — with dedicated teams, AI-supported commercial processing and communication without language barriers.",
      ctaPrimary: "Request a free quote",
      ctaSecondary: "Explore services",
      pills: ["Modular cleaning", "Dedicated teams", "DE · EN · SR/HR · HI · AI assistance"],
      videoCaption: "Our teams at work — systematic, professional equipment & cleaning robot",
      scroll: "Scroll down",
    },
    usp: {
      label: "Our strength",
      title: "Public buildings need more than cleaning. They need reliability with a system.",
      sub: "Six reasons why public sector clients choose BUNDLER FM. Click a strength for more details.",
      cards: [
        {
          title: "Specialized in public sector clients",
          text: "Authorities, schools, municipalities, institutes: we think like the public sector — and prepare the project start before it begins.",
          more: "After the contract is awarded, there is no time: staff must be recruited, trained and briefed — at universities, for example, in sensitive areas such as laboratories and security-level rooms. On top come seasonal effects: vacation periods, increased sick leave, school holidays — they affect institutes and service providers alike. Those who do not prepare start with staffing gaps, and quality collapses exactly in the critical ramp-up phase. This preparation is our core business: geographic analysis of buildings, opening hours, areas with deadlines, staff planning across vacation and holiday periods — our central AI handles a large part of the project-start preparation. Staff is 100% available and selected specifically for your property. We address institutes directly — without intermediary contacts. This gives your operations a functioning infrastructure to deliver the promised service. And if you wish: we hand over all elaborated steps to your management level after completion.",
        },
        {
          title: "Dedicated teams — selected exactly for your property",
          text: "No coincidence in staffing: we assign employees who precisely match your requirements.",
          more: "Changing faces mean new onboarding every time. Staffing gaps during vacation and holiday periods lead to visible quality drops — and unclear key arrangements become a security problem in the public sector. That is why we deliberately select our staff for every property — by working hours, the requirements of your service specification, age, language skills and mobility. We also consider our teams' private circumstances so the assignment stays stable long-term. Vacation periods are managed with early-planned replacements; key handovers and key management are firmly organized. The result: time-fixed processes that stay flexible at the same time — and always the same faces on site.",
        },
        {
          title: "Project start & coordination — we take care of everything",
          text: "From the initial property start to ongoing support: we coordinate independently — administratively and on site.",
          more: "The project start decides the entire contract: rooms must be ready by fixed times, events continue — and when changing service providers, knowledge loss and legal pitfalls loom: in a transfer of undertaking under § 613a BGB, the predecessor's staff may transfer with all rights; if this goes unchecked, supply gaps and liability issues arise exactly at the start. We staff and equip your property exactly as needed — for example, preparing several lecture halls at a university simultaneously by a fixed time. We handle event coordination, support, temporary help and service-related tasks of any kind, and when changing providers we review the legal framework early — so neither knowledge nor supply is lost. We work out your contact persons together with you; you arrange inspection walkthroughs directly with us. BUNDLER FM takes administrative and local processes off your hands: planning tailored to your needs, acceptance handled by us instead of you.",
        },
        {
          title: "Digital back office with AI",
          text: "Inquiries, invoices and records run digitally and AI-supported — fast, precise, no paper chaos.",
          more: "Paper chaos and unclear invoices cost administrations time. Missing digital records become a problem during audits and controlling — and inquiries get lost in overflowing inboxes. With us, your inquiry automatically reaches the right contact: our AI detects whether it concerns technical matters, commercial topics or management and forwards it instantly. We process invoices and performance records digitally and AI-supported — in the future also directly connected to accounting systems like lexoffice. For you this means: less administrative effort, faster answers, transparent processes.",
        },
        {
          title: "Communication without language barriers",
          text: "Live translation via headset: your cleaner speaks her language — you hear it instantly in German.",
          more: "When instructions fail because of language, services are carried out incorrectly or not at all — in sensitive areas such as laboratories this can become a safety risk, and complaints escalate because nobody understands where the problem lies. Our teams work multilingually — for us that is not an obstacle but a strength: AI-supported headsets translate live in both directions. Your cleaner speaks Serbian or Croatian into her headset, for example — you hear the translation in German in your ear in real time. And vice versa. Every piece of information arrives without loss — directly, personally, without detours.",
        },
        {
          title: "Digital room books & property data",
          text: "Room books, rooms and floor coverings always up to date: AI-supported data analysis — verified through real on-site inspections by our technical team.",
          more: "Outdated room books are a hidden risk: which rooms were updated? Are the actual room groups correct? Were construction measures recorded? Which floor coverings actually exist? Wrong data leads to wrong offers and expensive recalculations. We calculate exactly according to your actual needs — regardless of which coverings or room types your property has. This ensures that recalculations virtually never occur. Our AI analyzes your room book data and detects gaps; our tech-savvy team checks during real on-site inspections whether rooms, room groups and construction measures are up to date, and supplements the room book directly in the building. Commissioning, expansion measures and extensions are considered separately — so your data basis is always correct.",
        },
      ],
    },
    services: {
      label: "Services",
      title: "Maintenance cleaning — right inside your daily operations",
      chapters: [
        {
          num: "01",
          tag: "Our method",
          title: "Modular cleaning — our own way of working",
          text: "Instead of rigid cleaning plans, we work with a self-developed modular system that adapts precisely to your operations and opening hours. We are happy to show you exactly what is behind it in person — for example as part of your tender. What matters for you is the result: cleaning that adapts to your day — not the other way around.",
        },
        {
          num: "02",
          tag: "Why so efficient",
          title: "Digital processes streamline every step",
          text: "Inquiries automatically reach the right place, on-site coordination happens via headset live translation without delay, performance records are created digitally. No media disruptions, no waiting times, no duplicate routes — saving hours every single day.",
        },
        {
          num: "03",
          tag: "Cost & quality",
          title: "Same quality, lower costs",
          text: "Because we calculate exactly according to your needs instead of blanket assumptions, recalculations virtually never occur. By focusing fully on maintenance cleaning and working in modules, our area performance (m²/h) sits well above the industry benchmark — with the same or better quality. Dedicated teams lose no onboarding time, administration runs digitally: that is the difference between cheap and economical.",
        },
      ],
      extraTag: "On request",
      extra: "Clearance and decluttering, driving service & mail runs, fleet and vehicle detailing, temporary stand-in cleaning and more — talk to us. We put together the right service package for your building.",
    },
    team: {
      label: "Team",
      title: "Your contacts",
      sub: "Three clear levels, one standard: your inquiry always reaches the right place directly — from management to the departments.",
      emailLabel: "Write email",
    },
    references: {
      label: "References",
      title: "Public buildings are our home. And our experience.",
      sub: "Universities, schools, authorities, municipalities: these are exactly the buildings we are built for — with a team that has worked in major public cleaning projects for years.",
      galleryCaption: "The types of buildings we work for",
      gallery: ["Universities", "Schools", "Authorities", "Municipalities"],
      trustLabel: "Experience that counts",
      trust: [
        {
          title: "Years of experience in major projects",
          text: "Our management has been responsible for cleaning projects in large public buildings for years — from universities to schools. This experience is part of every concept we create.",
        },
        {
          title: "The public sector perspective",
          text: "Our Technical Director currently works as an area manager at a university. We know tenders, deadlines and service specifications first-hand — from your side of the table.",
        },
        {
          title: "Personal and reachable",
          text: "With us you speak directly to the management — no hotline, no waiting loop. First clients enjoy our highest priority and personal attention.",
        },
      ],
      youngTitle: "Young as a company. Experienced as a team.",
      youngText: "BUNDLER FM is a UG in formation — our reference list is only just filling up. Our departments, processes and digital back office, however, stand on years of experience from large public properties. If you are looking for a partner who takes every project personally and seriously: become one of our first reference clients.",
      cta: "Get in touch now",
    },
    marquee: [
      "No language barriers — AI-supported communication",
      "Maintenance cleaning for public buildings",
      "Digital invoice processing",
      "Dedicated teams — consistent quality",
      "Facility management, reimagined",
    ],
    contact: {
      label: "Contact",
      title: "Send a free inquiry",
      sub: "Non-binding and free of charge. Just send your inquiry — our AI automatically finds the right contact person for your concern in the background.",
      name: "Your name",
      namePh: "John Doe",
      email: "Your email",
      emailPh: "john@example.com",
      message: "Your message",
      messagePh: "What is it about? E.g. quote request for maintenance cleaning of a school building …",
      submit: "Send inquiry",
      sending: "Sending …",
      successTitle: "Inquiry received",
      success: "Thank you! Our AI has automatically forwarded your inquiry to the right contact person.",
      error: "Something went wrong. Please try again or write to info@bundler-fm.de.",
      free: "Free · Non-binding · Reply usually within 24 hours",
      aiHint: "No selection needed — the AI finds the right contact person in the background",
    },
    footer: {
      tagline: "Facility management — reimagined.",
      company: "BUNDLER FM UG (in Gründung)",
      address: "Zum Isetal 1 · 38518 Gifhorn",
      phone: "Tel. +49 5371 9394742",
      email: "info@bundler-fm.de",
      socialSoon: "Social media coming soon",
      rights: "© 2026 BUNDLER FM. All rights reserved.",
      admin: "Admin",
    },
  },
  sh: {
    nav: {
      usp: "Prednosti",
      services: "Usluge",
      team: "Tim",
      references: "Reference",
      contact: "Kontakt",
      cta: "Pošaljite upit",
    },
    hero: {
      label: "Facility management — na nov način",
      line1: "Čiste javne zgrade.",
      line2: "Digitalni procesi.",
      line3: "Bez jezičkih barijera.",
      sub: "BUNDLER FM je vaš partner za redovno čišćenje javnih zgrada — sa stalnim timovima, AI-podržanom komercijalnom obradom i komunikacijom bez jezičkih barijera.",
      ctaPrimary: "Pošaljite besplatni upit",
      ctaSecondary: "Otkrijte usluge",
      pills: ["Modularno čišćenje", "Stalni timovi", "DE · EN · SR/HR · HI · AI asistencija"],
      videoCaption: "Naši timovi na terenu — sa sistemom, profesionalnom opremom i robotom za čišćenje",
      scroll: "Skrolujte nadole",
    },
    usp: {
      label: "Naša snaga",
      title: "Javnim zgradama treba više od čišćenja. Treba im pouzdanost sa sistemom.",
      sub: "Šest razloga zašto se javni naručioci odlučuju za BUNDLER FM. Kliknite na prednost za više detalja.",
      cards: [
        {
          title: "Specijalizovani za javne naručioce",
          text: "Ustanove, škole, opštine, instituti: mi mislimo kao javni nosilac — i pripremamo početak rada na objektu pre nego što počne.",
          more: "Nakon dodele ugovora nema vremena: osoblje mora biti obezbeđeno, obučeno i uvedeno u posao — na univerzitetima, na primer, u osetljivim prostorijama kao što su laboratorije i prostorije sa sigurnosnim nivoima. Tu dolaze i sezonski efekti: godišnji odmore, povećana bolovanja, školski raspusti — oni pogađaju i institute i izvođače podjednako. Ko to ne pripremi, počinje sa rupama u osoblju, a kvalitet se ruši upravo u kritičnoj početnoj fazi. Ova priprema je naše osnovno znanje: geografska analiza zgrada, radno vreme, prostorije sa rokovima, planiranje osoblja kroz periode godišnjih odmora i raspusta — naša centralna AI preuzima veliki deo pripreme za početak projekta. Osoblje je 100% prisutno i ciljano birano za vaš objekat. Institute kontaktiramo direktno — bez posrednika. Tako vaša operativa ima funkcionalnu infrastrukturu za pružanje ponuđene usluge. I ako želite: sve izrađene korake nakon završetka predajemo vašem rukovodstvu.",
        },
        {
          title: "Stalni timovi — pažljivo izabrani za vaš objekat",
          text: "Bez slučajnosti pri izboru osoblja: vaš objekat popunjavamo zaposlenima koji tačno odgovaraju vašim zahtevima.",
          more: "Promenljiva lica svaki put znače novo uvođenje u posao. Rupe u osoblju tokom godišnjih odmora i raspusta dovode do vidljivih padova kvaliteta — a nejasni dogovori o ključevima postaju sigurnosni problem u javnom sektoru. Zato za svaki objekat pažljivo biramo naše zaposlene — prema radnom vremenu, zahtevima vaše specifikacije usluga, starosti, jezičkim znanjima i mobilnosti. Pri tom uzimamo u obzir i privatne okolnosti naših timova, kako bi popuna dugoročno ostala stabilna. Godišnje odmore rešavamo rano planiranim zamena, predaja ključeva i upravljanje ključevima su čvrsto organizovani. Rezultat: vremenski fiksirani procesi koji istovremeno ostaju fleksibilni — i uvek ista lica kod vas na terenu.",
        },
        {
          title: "Početak rada i koordinacija — sve preuzimamo na sebe",
          text: "Od početka rada na objektu do stalne podrške: koordiniramo samostalno — administrativno i na terenu.",
          more: "Početak rada odlučuje o celom ugovoru: prostorije moraju biti gotove do fiksnih termina, događaji se nastavljaju — a pri promeni izvođača prete gubitak znanja i pravne zamke: pri preuzimanju preduzeća po § 613a BGB osoblje prethodnika može preći sa svim pravima; ako se to ne proveri, nastaju rupe u snabdevanju i pitanja odgovornosti baš na početku. Vaš objekat opremamo tačno prema potrebi — na primer na univerzitetu nekoliko amfiteatara istovremeno do fiksnog termina. Preuzimamo koordinaciju događaja, podršku, pomoćne poslove i usluge svake vrste, a pri promeni izvođača rano proveravamo pravne okvire — tako da se ne gubi ni znanje ni snabdevanje. Vaše kontakt osobe izrađujemo zajedno sa vama, kontrolne obilaske dogovarate direktno sa nama. Administrativne i lokalne procese BUNDLER FM preuzima umesto vas: planiranje prilagođeno vašim potrebama, prijem radova radimo mi umesto vas.",
        },
        {
          title: "Digitalna administracija sa AI",
          text: "Upiti, računi i dokazi idu digitalno i uz AI-podršku — brzo, precizno, bez papirologije.",
          more: "Papirni haos i nejasni računi koštaju administraciju vreme. Nedostajući digitalni dokazi postaju problem pri kontrolama — a upiti se gube u prepunim poštanskim sandučetima. Kod nas vaš upit automatski stiže pravoj osobi: naša AI prepoznaje da li se radi o tehnici, komercijalnim temama ili rukovodstvu i odmah prosleđuje. Račune i dokaze o izvršenim uslugama obrađujemo digitalno i uz AI-podršku — u budućnosti i direktno povezano sa knjigovodstvenim sistemima kao što je lexoffice. Za vas to znači: manje administrativnog posla, brži odgovori, transparentni procesi.",
        },
        {
          title: "Komunikacija bez jezičkih barijera",
          text: "Prevod uživo preko slušalica: vaša čistačica govori svoj jezik — vi je odmah čujete na nemačkom.",
          more: "Kada instrukcije ne uspeju zbog jezika, usluge se izvode pogrešno ili uopšte ne — u osetljivim prostorijama kao što su laboratorije to može postati sigurnosni rizik, a žalbe eskaliraju jer niko ne razume gde je problem. Naši timovi rade višejezično — za nas to nije prepreka već snaga: AI-podržane slušalice prevode uživo u oba smera. Vaša čistačica govori na primer srpskohrvatski u slušalicu — vi prevod čujete u realnom vremenu na nemačkom u svom uhu. I obrnuto. Tako svaka informacija stiže bez gubitaka — direktno, lično, bez zaobilaznica.",
        },
        {
          title: "Digitalne knjige prostorija i podaci o objektu",
          text: "Knjige prostorija, prostorije i podne obloge uvek ažurni: AI-podržana analiza podataka — proverena pravim obilascima našeg tehničkog tima.",
          more: "Zastarele knjige prostorija su skriveni rizik: koje prostorije su ažurirane? Da li stvarne grupe prostorija odgovaraju? Da li su građevinske mere unete? Koje podne obloge stvarno postoje? Pogrešni podaci vode ka pogrešnim ponudama i skupim naknadnim kalkulacijama. Mi kalkulišemo tačno prema vašoj stvarnoj potrebi — nezavisno od toga koje obloge ili tipove prostorija vaš objekat ima. Tako obezbeđujemo da se naknadne kalkulacije gotovo ne dešavaju. Naša AI analizira podatke vaše knjige prostorija i prepoznaje praznine; naš tehnički potkovan tim proverava pri pravim obilascima na terenu da li su prostorije, grupe prostorija i građevinske mere ažurne, i dopunjuje knjigu prostorija direktno u objektu. Puštanje u rad, dogradnju i proširenja posmatramo posebno — kako bi vaša baza podataka uvek bila tačna.",
        },
      ],
    },
    services: {
      label: "Usluge",
      title: "Redovno čišćenje — usred operativnog dnevnog toka",
      chapters: [
        {
          num: "01",
          tag: "Naša metoda",
          title: "Modularno čišćenje — naš sopstveni način rada",
          text: "Umesto krutih planova čišćenja po šablonu radimo sa sopstveno razvijenim modularnim sistemom, koji se tačno prilagođava vašem poslovanju i vašem radnom vremenu. Šta se tačno krije iza toga, rado vam pokazujemo lično — na primer u okviru vašeg tendera. Za vas se računa rezultat: čišćenje koje se prilagođava vašem danu — a ne obrnuto.",
        },
        {
          num: "02",
          tag: "Zašto tako efikasno",
          title: "Digitalni procesi pojednostavljuju svaki korak",
          text: "Upiti automatski stižu na pravo mesto, dogovore na terenu vodimo preko slušalica sa prevodom uživo bez odlaganja, dokazi o uslugama nastaju digitalno. Bez prekida medija, bez čekanja, bez dvostrukih puteva — to svaki dan štedi sate.",
        },
        {
          num: "03",
          tag: "Troškovi i kvalitet",
          title: "Isti kvalitet, manji troškovi",
          text: "Pošto kalkulišemo tačno prema vašoj potrebi umesto po paušalnim pretpostavkama, naknadne kalkulacije gotovo izostaju. Kroz fokusiranje na redovno čišćenje i modularne procese naša površinska učinkovitost (m²/h) je znatno iznad proseka grane — pri istom ili boljem kvalitetu. Stalni timovi ne gube vreme na uvođenje, administracija radi digitalno: to je razlika između jeftino i ekonomično.",
        },
      ],
      extraTag: "Na upit",
      extra: "Ispražnjavanje i raščlanjivanje, vozačka služba i dostava pošte, održavanje i priprema voznog parka i automobila, zamensko čišćenje i više — javite nam se. Sastavljamo odgovarajući paket usluga za vašu zgradu.",
    },
    team: {
      label: "Tim",
      title: "Vaše kontakt osobe",
      sub: "Tri jasne razine, jedan standard: vaš upit uvek stiže direktno na pravo mesto — od rukovodstva do odjela.",
      emailLabel: "Pošaljite e-mail",
    },
    references: {
      label: "Reference",
      title: "Javne zgrade su naš dom. I naše iskustvo.",
      sub: "Univerziteti, škole, ustanove, opštine: upravo za ove zgrade smo napravljeni — sa timom koji godinama radi u velikim projektima čišćenja javnih objekata.",
      galleryCaption: "Tipovi zgrada za koje radimo",
      gallery: ["Univerziteti", "Škole", "Ustanove", "Opštine"],
      trustLabel: "Iskustvo koje se računa",
      trust: [
        {
          title: "Višegodišnje iskustvo iz velikih projekata",
          text: "Naše rukovodstvo je godinama vodilo projekte čišćenja u velikim javnim objektima — od univerziteta do škola. To iskustvo je ugrađeno u svaki naš koncept.",
        },
        {
          title: "Pogled javnog naručioca",
          text: "Naš tehnički direktor trenutno radi kao rukovodilac oblasti na univerzitetu. Poznajemo dodele, rokove i specifikacije usluga iz prve ruke — sa vaše strane stola.",
        },
        {
          title: "Lično i dostupno",
          text: "Kod nas razgovarate direktno sa rukovodstvom — bez pozivnog centra, bez čekanja. Prvi klijenti uživaju kod nas najviši prioritet i ličnu negu.",
        },
      ],
      youngTitle: "Mladi kao firma. Iskusni kao tim.",
      youngText: "BUNDLER FM je UG u osnivanju — naša lista referenci se tek popunjava. Naši odjeli, procesi i digitalna administracija stoje, nasuprot tome, na višegodišnjem iskustvu iz velikih javnih objekata. Ako tražite partnera koji svaki zadatak shvata lično i ozbiljno: postanite jedan od naših prvih referentnih klijenata.",
      cta: "Uspostavite prvi kontakt",
    },
    marquee: [
      "Bez jezičkih barijera — AI-podržana komunikacija",
      "Redovno čišćenje javnih zgrada",
      "Digitalna obrada računa",
      "Stalni timovi — stalni kvalitet",
      "Facility management, novo promišljen",
    ],
    contact: {
      label: "Kontakt",
      title: "Pošaljite besplatni upit",
      sub: "Neobavezujuće i besplatno. Jednostavno pošaljite upit — naša AI u pozadini automatski pronalazi pravu kontakt osobu za vaš zahtev.",
      name: "Vaše ime",
      namePh: "Petar Petrović",
      email: "Vaš e-mail",
      emailPh: "petar@primer.rs",
      message: "Vaša poruka",
      messagePh: "O čemu se radi? Npr. zahtev za ponudu redovnog čišćenja školske zgrade …",
      submit: "Pošaljite upit",
      sending: "Šalje se …",
      successTitle: "Upit primljen",
      success: "Hvala vam! Naša AI je vaš upit automatski prosledila zaduženoj kontakt osobi.",
      error: "Nešto je pošlo po zlu. Pokušajte ponovo ili pišite na info@bundler-fm.de.",
      free: "Besplatno · Neobavezujuće · Odgovor obično u roku od 24 sata",
      aiHint: "Nije potreban izbor — AI u pozadini pronalazi pravu kontakt osobu",
    },
    footer: {
      tagline: "Facility management — novo promišljen.",
      company: "BUNDLER FM UG (in Gründung)",
      address: "Zum Isetal 1 · 38518 Gifhorn",
      phone: "Tel. +49 5371 9394742",
      email: "info@bundler-fm.de",
      socialSoon: "Društvene mreže uskoro",
      rights: "© 2026 BUNDLER FM. Sva prava zadržana.",
      admin: "Admin",
    },
  },
  hi: {
    nav: {
      usp: "विशेषताएँ",
      services: "सेवाएँ",
      team: "टीम",
      references: "संदर्भ",
      contact: "संपर्क",
      cta: "पूछताछ भेजें",
    },
    hero: {
      label: "सुविधा प्रबंधन — नए अंदाज़ में",
      line1: "साफ-सुथरी सार्वजनिक इमारतें।",
      line2: "डिजिटल प्रक्रियाएँ।",
      line3: "कोई भाषा बाधा नहीं।",
      sub: "BUNDLER FM सार्वजनिक इमारतों की रखरखाव सफाई के लिए आपका भागीदार है — समर्पित टीमों, AI-समर्थित वाणिज्यिक प्रसंस्करण और बिना भाषा बाधा के संचार के साथ।",
      ctaPrimary: "मुफ़्त पूछताछ करें",
      ctaSecondary: "सेवाएँ देखें",
      pills: ["मॉड्यूलर सफाई", "समर्पित टीमें", "DE · EN · SR/HR · HI · AI सहायता"],
      videoCaption: "हमारी टीमें काम पर — व्यवस्थित तरीके, पेशेवर उपकरण और सफाई रोबोट के साथ",
      scroll: "नीचे स्क्रॉल करें",
    },
    usp: {
      label: "हमारी ताकत",
      title: "सार्वजनिक इमारतों को सिर्फ सफाई नहीं चाहिए। उन्हें व्यवस्था के साथ विश्वसनीयता चाहिए।",
      sub: "छह कारण जिनसे सार्वजनिक क्षेत्र के ग्राहक BUNDLER FM चुनते हैं। अधिक जानकारी के लिए किसी ताकत पर क्लिक करें।",
      cards: [
        {
          title: "सार्वजनिक ग्राहकों में विशेषज्ञ",
          text: "प्राधिकरण, स्कूल, नगरपालिकाएँ, संस्थान: हम सार्वजनिक क्षेत्र की तरह सोचते हैं — और प्रोजेक्ट शुरू होने से पहले ही उसकी तैयारी कर लेते हैं।",
          more: "अनुबंध मिलने के बाद समय नहीं रहता: कर्मचारियों को खोजना, प्रशिक्षित करना और काम पर लगाना होता है — विश्वविद्यालयों में उदाहरण के लिए प्रयोगशालाओं और सुरक्षा-कक्षों जैसे संवेदनशील क्षेत्रों में। इसके ऊपर मौसमी प्रभाव आते हैं: छुट्टियों का समय, बढ़ी हुई बीमारियाँ, स्कूल की छुट्टियाँ — ये संस्थानों और सेवा प्रदाताओं दोनों को समान रूप से प्रभावित करती हैं। जो इसकी तैयारी नहीं करता, वह कर्मचारियों की कमी के साथ शुरू होता है, और गुणवत्ता ठीक महत्वपूर्ण शुरुआती चरण में गिर जाती है। यह तैयारी हमारा मुख्य काम है: इमारतों का भौगोलिक विश्लेषण, खुलने का समय, समय-सीमा वाले क्षेत्र, छुट्टी और अवकाश अवधि के पार कर्मचारी नियोजन — हमारी केंद्रीय AI प्रोजेक्ट शुरू होने की तैयारी का बड़ा हिस्सा संभालती है। कर्मचारी 100% उपलब्ध होते हैं और विशेष रूप से आपकी संपत्ति के लिए चुने जाते हैं। हम संस्थानों से सीधे संपर्क करते हैं — बिना बिचौलियों के। इससे आपके संचालन को प्रस्तावित सेवा देने के लिए एक कार्यात्मक बुनियादी ढाँचा मिलता है। और यदि आप चाहें: पूरा होने के बाद हम सभी तैयार किए गए कदम आपके प्रबंधन स्तर को सौंप देते हैं।",
        },
        {
          title: "समर्पित टीमें — आपकी संपत्ति के लिए सटीक चयन",
          text: "कर्मचारी चयन में कोई संयोग नहीं: हम आपकी संपत्ति के लिए वे कर्मचारी नियुक्त करते हैं जो आपकी आवश्यकताओं से बिल्कुल मेल खाते हों।",
          more: "बदलते चेहरे हर बार नए प्रशिक्षण का मतलब हैं। छुट्टियों और अवकाश अवधि में कर्मचारियों की कमी दिखने वाली गुणवत्ता गिरावट की ओर ले जाती है — और चाबियों के अस्पष्ट इंतज़ाम सार्वजनिक क्षेत्र में सुरक्षा समस्या बन जाते हैं। इसलिए हम हर संपत्ति के लिए अपने कर्मचारियों का सावधानीपूर्वक चयन करते हैं — काम के घंटों, आपके सेवा-विवरण की आवश्यकताओं, आयु, भाषा कौशल और गतिशीलता के अनुसार। साथ ही हम अपनी टीमों की निजी परिस्थितियों पर भी विचार करते हैं ताकि तैनाती लंबे समय तक स्थिर रहे। छुट्टियों की अवधि हम जल्दी नियोजित स्थानापन्नों से संभालते हैं; चाबी सौंपना और चाबी प्रबंधन पूरी तरह संगठित है। परिणाम: समय-बद्ध प्रक्रियाएँ जो साथ ही लचीली रहती हैं — और आपके यहाँ हमेशा वही चेहरे।",
        },
        {
          title: "प्रोजेक्ट शुरुआत और समन्वय — हम सब कुछ संभालते हैं",
          text: "प्रारंभिक शुरुआत से लेकर निरंतर सहायता तक: हम स्वतंत्र रूप से समन्वय करते हैं — प्रशासनिक और साइट पर।",
          more: "प्रोजेक्ट की शुरुआत पूरा अनुबंध तय करती है: कमरे निश्चित समय तक तैयार होने चाहिए, कार्यक्रम चलते रहते हैं — और सेवा प्रदाता बदलने पर ज्ञान हानि और कानूनी जटिलताओं का खतरा रहता है: § 613a BGB के तहत उपक्रम हस्तांतरण में पूर्ववर्ती के कर्मचारी सभी अधिकारों के साथ स्थानांतरित हो सकते हैं; अगर इसकी जाँच न हो तो ठीक शुरुआत में आपूर्ति में कमी और देयता के मुद्दे उत्पन्न होते हैं। हम आपकी संपत्ति को बिल्कुल आवश्यकतानुसार सज्जित करते हैं — उदाहरण के लिए किसी विश्वविद्यालय में कई प्रवचन कक्ष एक साथ निश्चित समय तक तैयार करना। हम कार्यक्रम समन्वय, सहायता, अस्थायी मदद और हर प्रकार की सेवा-संबंधी कार्य संभालते हैं, और प्रदाता बदलने पर कानूनी ढाँचे की समय पर समीक्षा करते हैं — ताकि न ज्ञान खोए और न आपूर्ति। आपके संपर्क व्यक्ति हम आपके साथ मिलकर तय करते हैं; निरीक्षण भ्रमण आप सीधे हमसे करते हैं। BUNDLER FM प्रशासनिक और स्थानीय प्रक्रियाओं को आपसे हटा देता है: आपकी आवश्यकता के अनुरूप योजना, स्वीकृति आपके बजाय हमारे द्वारा।",
        },
        {
          title: "AI के साथ डिजिटल बैक-ऑफिस",
          text: "पूछताछ, चालान और रिकॉर्ड डिजिटल और AI-समर्थित चलते हैं — तेज़, सटीक, बिना कागज़ी उलझाव के।",
          more: "कागज़ी उलझाव और अस्पष्ट चालान प्रशासन का समय खाते हैं। लापता डिजिटल रिकॉर्ड ऑडिट और नियंत्रण के दौरान समस्या बन जाते हैं — और पूछताछ भरे इनबॉक्स में खो जाती हैं। हमारे यहाँ आपकी पूछताछ स्वचालित रूप से सही संपर्क व्यक्ति तक पहुँचती है: हमारी AI पहचानती है कि मामला तकनीकी है, वाणिज्यिक या प्रबंधन से संबंधित, और तुरंत अग्रेषित करती है। हम चालान और सेवा रिकॉर्ड डिजिटल और AI-समर्थित रूप से संसाधित करते हैं — भविष्य में lexoffice जैसी लेखांकन प्रणालियों से सीधे जुड़े हुए भी। आपके लिए इसका मतलब: कम प्रशासनिक प्रयास, तेज़ उत्तर, पारदर्शी प्रक्रियाएँ।",
        },
        {
          title: "बिना भाषा बाधा के संचार",
          text: "हेडसेट के माध्यम से लाइव अनुवाद: आपकी सफाईकर्मी अपनी भाषा बोलती है — आप उसे तुरंत जर्मन में सुनते हैं।",
          more: "जब निर्देश भाषा की वजह से विफल हो जाते हैं, तो सेवाएँ गलत या बिल्कुल नहीं की जातीं — प्रयोगशालाओं जैसे संवेदनशील क्षेत्रों में यह सुरक्षा जोखिम बन सकता है, और शिकायतें बढ़ जाती हैं क्योंकि कोई नहीं समझता कि समस्या कहाँ है। हमारी टीमें बहुभाषी काम करती हैं — हमारे लिए यह बाधा नहीं बल्कि ताकत है: AI-समर्थित हेडसेट दोनों दिशाओं में लाइव अनुवाद करते हैं। आपकी सफाईकर्मी उदाहरण के लिए हेडसेट में सर्बो-क्रोएशियन बोलती है — आप अनुवाद वास्तविक समय में जर्मन में अपने कान में सुनते हैं। और इसका उल्टा भी। इस तरह हर जानकारी बिना नुकसान के पहुँचती है — सीधे, व्यक्तिगत रूप से, बिना घूम-फिर कर।",
        },
        {
          title: "डिजिटल रूम-बुक और संपत्ति डेटा",
          text: "रूम-बुक, कमरे और फ़र्श हमेशा अद्यतित: AI-समर्थित डेटा विश्लेषण — हमारी तकनीकी टीम के वास्तविक निरीक्षणों द्वारा सत्यापित।",
          more: "पुरानी रूम-बुक एक छिपा हुआ जोखिम है: कौन से कमरे अद्यतन किए गए? क्या वास्तविक कक्ष-समूह सही हैं? क्या निर्माण कार्य दर्ज किए गए? वास्तव में कौन से फ़र्श हैं? गलत डेटा गलत प्रस्तावों और महंगी पुनर्गणनाओं की ओर ले जाता है। हम आपकी वास्तविक आवश्यकता के अनुसार सटीक गणना करते हैं — इस पर निर्भर किए बिना कि आपकी संपत्ति में कौन से फ़र्श या कमरे के प्रकार हैं। इस तरह हम सुनिश्चित करते हैं कि पुनर्गणना लगभग न हो। हमारी AI आपके रूम-बुक डेटा का विश्लेषण करती है और कमियाँ पहचानती है; हमारी तकनीकी रूप से दक्ष टीम वास्तविक निरीक्षणों में जाँचती है कि कमरे, कक्ष-समूह और निर्माण कार्य अद्यतित हैं या नहीं, और रूम-बुक को सीधे संपत्ति में पूरा करती है। कमीशनिंग, विस्तार कार्य और सम्प्रसारणों को हम अलग से देखते हैं — ताकि आपका डेटा आधार हमेशा सही रहे।",
        },
      ],
    },
    services: {
      label: "सेवाएँ",
      title: "रखरखाव सफाई — दैनिक संचालन के बीच में",
      chapters: [
        {
          num: "01",
          tag: "हमारी विधि",
          title: "मॉड्यूलर सफाई — हमारा अपना काम करने का तरीका",
          text: "तयशुदा पैटर्न वाली कठोर सफाई योजनाओं के बजाय हम एक स्व-विकसित मॉड्यूलर प्रणाली के साथ काम करते हैं, जो आपके संचालन और आपके खुलने के समय के अनुरूप बिल्कुल ढल जाती है। इसके पीछे वास्तव में क्या है, हम आपको खुशी से व्यक्तिगत रूप से दिखाते हैं — उदाहरण के लिए आपकी निविदा के दौरान। आपके लिए परिणाम मायने रखता है: ऐसी सफाई जो आपके दिन के अनुरूप ढले — न कि इसका उल्टा।",
        },
        {
          num: "02",
          tag: "इतनी कुशल क्यों",
          title: "डिजिटल प्रक्रियाएँ हर कदम सरल बनाती हैं",
          text: "पूछताछ स्वचालित रूप से सही जगह पहुँचती है, साइट पर परामर्श हम हेडसेट लाइव-अनुवाद से बिना देरी के करते हैं, सेवा प्रमाण डिजिटल रूप से बनते हैं। कोई मीडिया-ब्रेक नहीं, कोई प्रतीक्षा नहीं, कोई दोहरे रास्ते नहीं — इससे हर दिन घंटों बचते हैं।",
        },
        {
          num: "03",
          tag: "लागत और गुणवत्ता",
          title: "वही गुणवत्ता, कम लागत",
          text: "क्योंकि हम मोटे अनुमानों के बजाय आपकी वास्तविक आवश्यकता के अनुसार गणना करते हैं, पुनर्गणना लगभग नहीं होती। रखरखाव सफाई और मॉड्यूलर प्रक्रियाओं पर ध्यान केंद्रित करने से हमारी क्षेत्र दक्षता (m²/h) उद्योग-मानक से काफी ऊपर है — वही या बेहतर गुणवत्ता पर। समर्पित टीमें प्रशिक्षण का समय नहीं खोतीं, प्रशासन डिजिटल चलता है: यही सस्ते और किफ़ायती के बीच का अंतर है।",
        },
      ],
      extraTag: "अनुरोध पर",
      extra: "खाली करना और निस्तारण, ड्राइविंग सेवा और डाक-चक्कर, वाहन बेड़े और कार की देखभाल, अस्थायी सफाई और भी बहुत कुछ — हमसे बात करें। हम आपकी इमारत के लिए सही सेवा पैकेज तैयार करते हैं।",
    },
    team: {
      label: "टीम",
      title: "आपके संपर्क व्यक्ति",
      sub: "तीन स्पष्ट स्तर, एक मानक: आपकी पूछताछ हमेशा सीधे सही जगह पहुँचती है — प्रबंधन से लेकर विभागों तक।",
      emailLabel: "ईमेल लिखें",
    },
    references: {
      label: "संदर्भ",
      title: "सार्वजनिक इमारतें हमारा घर हैं। और हमारा अनुभव।",
      sub: "विश्वविद्यालय, स्कूल, प्राधिकरण, नगरपालिकाएँ: हम बिल्कुल इन्हीं इमारतों के लिए बने हैं — एक ऐसी टीम के साथ जो वर्षों से बड़े सार्वजनिक सफाई प्रोजेक्टों में काम कर रही है।",
      galleryCaption: "इमारतों के प्रकार, जिनके लिए हम काम करते हैं",
      gallery: ["विश्वविद्यालय", "स्कूल", "प्राधिकरण", "नगरपालिकाएँ"],
      trustLabel: "अनुभव जो मायने रखता है",
      trust: [
        {
          title: "बड़े प्रोजेक्टों का वर्षों का अनुभव",
          text: "हमारे प्रबंधन ने वर्षों तक बड़ी सार्वजनिक इमारतों में सफाई प्रोजेक्टों की ज़िम्मेदारी संभाली है — विश्वविद्यालयों से लेकर स्कूलों तक। यह अनुभव हमारे हर कॉन्सेप्ट में शामिल है।",
        },
        {
          title: "सार्वजनिक क्षेत्र का नज़रिया",
          text: "हमारे तकनीकी निदेशक वर्तमान में एक विश्वविद्यालय में क्षेत्र प्रबंधक के रूप में कार्यरत हैं। हम निविदाओं, समय-सीमाओं और सेवा-विवरणों को प्रत्यक्ष रूप से जानते हैं — मेज़ के आपके पहलू से।",
        },
        {
          title: "व्यक्तिगत और सुलभ",
          text: "हमारे यहाँ आप सीधे प्रबंधन से बात करते हैं — बिना हॉटलाइन, बिना प्रतीक्षा कतार के। पहले ग्राहकों को हमारे यहाँ सर्वोच्च प्राथमिकता और व्यक्तिगत देखभाल मिलती है।",
        },
      ],
      youngTitle: "कंपनी के रूप में नई। टीम के रूप में अनुभवी।",
      youngText: "BUNDLER FM स्थापना-चरण में एक UG है — हमारी संदर्भ सूची अभी भर ही रही है। इसके विपरीत हमारे विभाग, प्रक्रियाएँ और डिजिटल बैक-ऑफिस बड़ी सार्वजनिक इमारतों के वर्षों के अनुभव पर टिके हैं। यदि आप ऐसा भागीदार खोज रहे हैं जो हर प्रोजेक्ट को व्यक्तिगत रूप से गंभीरता से लेता है: हमारे पहले संदर्भ ग्राहकों में से एक बनें।",
      cta: "अभी संपर्क करें",
    },
    marquee: [
      "कोई भाषा बाधा नहीं — AI-समर्थित संचार",
      "सार्वजनिक इमारतों की रखरखाव सफाई",
      "डिजिटल चालान प्रसंस्करण",
      "समर्पित टीमें — एक समान गुणवत्ता",
      "सुविधा प्रबंधन, नए अंदाज़ में",
    ],
    contact: {
      label: "संपर्क",
      title: "मुफ़्त पूछताछ भेजें",
      sub: "गैर-बाध्यकारी और निःशुल्क। बस पूछताछ भेजें — हमारी AI पृष्ठभूमि में स्वचालित रूप से आपके मामले के लिए सही संपर्क व्यक्ति ढूँढ़ लेती है।",
      name: "आपका नाम",
      namePh: "राहुल शर्मा",
      email: "आपका ईमेल",
      emailPh: "rahul@udaharan.in",
      message: "आपका संदेश",
      messagePh: "विषय क्या है? जैसे स्कूल भवन की रखरखाव सफाई के लिए कोटेशन अनुरोध …",
      submit: "पूछताछ भेजें",
      sending: "भेजा जा रहा है …",
      successTitle: "पूछताछ प्राप्त हुई",
      success: "धन्यवाद! हमारी AI ने आपकी पूछताछ स्वचालित रूप से सही संपर्क व्यक्ति को अग्रेषित कर दी है।",
      error: "कुछ गलत हो गया। कृपया पुनः प्रयास करें या info@bundler-fm.de पर लिखें।",
      free: "निःशुल्क · गैर-बाध्यकारी · उत्तर आमतौर पर 24 घंटों के भीतर",
      aiHint: "चयन की आवश्यकता नहीं — AI पृष्ठभूमि में सही संपर्क व्यक्ति ढूँढ़ लेती है",
    },
    footer: {
      tagline: "सुविधा प्रबंधन — नए अंदाज़ में।",
      company: "BUNDLER FM UG (in Gründung)",
      address: "Zum Isetal 1 · 38518 Gifhorn",
      phone: "Tel. +49 5371 9394742",
      email: "info@bundler-fm.de",
      socialSoon: "सोशल मीडिया जल्द आ रहा है",
      rights: "© 2026 BUNDLER FM. सर्वाधिकार सुरक्षित।",
      admin: "एडमिन",
    },
  },
};
